module.exports = __webpack_public_path__ + "static/zen-and-the-art-of-motorcycle-maintenance-d23bdce91dfbc3b2730a81057f7dc12c.jpg";